import { SEPARATOR, convertSimpleChartToLineData } from '../../utils';
import { IChartRequest, IChartDataVeGet1Response, IChartSummary, TimeFrame, Interval, IChartDataVeGet1Request } from './models';

export const formChartParams = ({
  instrumentCode,
  interval = `OneMinute`,
  includePreviousClose = true,
  includeVolume = false,
  timeframe = `OneDay`
}: IChartRequest) => ({
  instrumentCode,
  interval,
  includePreviousClose,
  includeVolume,
  timeframe
});

export const getChartKeyFromRequest = (props: IChartRequest) => {
  const { instrumentCode, interval, includePreviousClose, includeVolume, timeframe } = formChartParams(props);
  return ['simple', instrumentCode, timeframe, interval, includePreviousClose ? 1 : 0, includeVolume ? 1 : 0].join(SEPARATOR);
};

export const getChartKeysFromQueries = (query: IChartRequest | IChartRequest[]) =>
  Array.isArray(query) ? query.map((q) => getChartKeyFromRequest(q)) : [getChartKeyFromRequest(query)];

export const getQueryFromChartKey = (key: string): IChartRequest => {
  const params = key.split(SEPARATOR);
  return {
    // The first param will be chart type
    instrumentCode: params[1],
    timeframe: params[2] as TimeFrame,
    interval: params[3] as Interval,
    includePreviousClose: params[4] === '1',
    includeVolume: params[5] === '1'
  };
};

export const formChartsApiQuery = (key: string): IChartDataVeGet1Request => {
  const request = getQueryFromChartKey(key);

  return {
    TimeFrame: request.timeframe,
    Instrument: request.instrumentCode,
    Interval: request.interval,
    IncludeVolume: request.includeVolume,
    IncludePreviousClose: request.includePreviousClose,
    UTCDateFormat: request.uTCDateFormat
  };
};

export const transformChartResponse = (
  instrumentCode: string,
  { SplitIndex, Stats, CurrencySymbolPosition, CurrencySymbol, UTCOffset, PreviousClose, TimeRange }: IChartDataVeGet1Response
): IChartSummary => ({
  instrumentCode,
  splitIndex: SplitIndex,
  currencySymbol: CurrencySymbol,
  currencySymbolPosition: CurrencySymbolPosition,
  utcOffset: UTCOffset,
  previousClose: PreviousClose,
  stats: convertSimpleChartToLineData(Stats),
  timeRange: TimeRange
});
